/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V3SegmentorDeploymentResults {
    'totalSegments'?: number;
    'successfullyRedeployed'?: number;
    'failedRedeployments'?: number;
    'failedSegmentIds'?: Array<string>;
    'message'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "totalSegments",
            "baseName": "totalSegments",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "successfullyRedeployed",
            "baseName": "successfullyRedeployed",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "failedRedeployments",
            "baseName": "failedRedeployments",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "failedSegmentIds",
            "baseName": "failedSegmentIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3SegmentorDeploymentResults.attributeTypeMap;
    }

    public constructor() {
    }
}

